<script lang="ts" setup>
import SubHeader from '~/components/mobile/layouts/sub-header.vue'
import LoadingSpin from '~common/loading-spin.vue'
import { useInstruction } from '~composables/instruction/use-instruction.ts'
import { useLogin } from '~/composables/account/use-login'

const route = useRoute()
const { isLogged } = useLogin()
const {
  loading,
  postDetail,
  postContentRef,
  breadcrumbTitle,
  fetchInstructionData,
  transactionNavigation,
  navigateToTransaction
} = useInstruction()

await fetchInstructionData(typeof route.params.slug === 'string' ? route.params.slug : undefined)
</script>

<template>
  <section class="about">
    <SubHeader :title="breadcrumbTitle" linkBack="/huong-dan" />
    <div class="about__block">
      <div class="container">
        <div class="about__content">
          <LoadingSpin v-if="loading" />
          <template v-if="!loading">
            <div ref="postContentRef" class="about__content--txt" v-html="postDetail"></div>
          </template>

          <ClientOnly>
            <div v-if="isLogged && transactionNavigation">
              <div class="instruction-footer-content">
                {{ transactionNavigation.text }}
                <button class="button main main--primary text-nowrap" @click="navigateToTransaction">
                  {{ transactionNavigation.button }}
                </button>
              </div>
            </div>
          </ClientOnly>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@import '~scssAsset/mobile/pages/about/index.scss';
</style>
